import { Moment } from 'moment';
import {
  Option,
  booleanOptions,
  tipoSerieOptions,
  negociacaoSecundariaOptions,
  depositariaEmissaoOptions,
  naturezaPessoaOptions,
  tipoDistribuicaoPublicaOptions,
  unidadeFederativaOptions,
  tipoLiquidacaoOptions,
  contraparteRecebedoraOptions,
} from 'common/genericOptions';


import { typedAction } from 'store/modules/base';
import { EmissaoStatus, InvestidorResponse } from 'common/genericTypes';
import { MultaMoraFieldsInterface, multaMoraFieldsInitialState } from 'common/interfaces/MultaMoraFields';

export interface CaracteristicasState extends MultaMoraFieldsInterface {
  // codigoInstrumentoFinanceiro: string;
  id?: string;
  draftId?: string;
  isin: string;
  numeroEmissao: string;
  numeroSerie: string;
  statusEmissao: EmissaoStatus;
  tipoSerie: Option;
  regimeFiduciario: Option;
  coobrigacao: Option;
  distribuicaoPublica: Option;
  tipoDistribuicaoPublica: Option;
  contraparteRecebedora: Option;
  negociacaoSecundariaPor: Option;
  termoSecuritizacaoFormalizado: Option;
  depositariaEmissao: Option;
  codigoCvmCiaSecuritizadora: string;
  utilizacaoAnuncioInicioDistribuicao: Option;
  ufLocalEmissao: Option;
  localEmissao: string;
  dataEncerramentoDistribuicao?: Moment;
  classificadoraRisco1?: string;
  rating1?: string;
  classificadoraRisco2?: string;
  rating2?: string;
  ufLocalPagamento: Option;
  localPagamento: string;
  averbadoEmCartorio: Option;
  registroNaInstituicaoCustodiante: Option;
  utilizacaoFaculdadeParagrafo3Art7: Option;
  garantiaFlutuante: Option;
  tipoGarantia: string;
  ativoGarantia: string;
  valorGarantia: number;
  nomeResponsavelPelasInformacoesDRI: string;
  emailResponsavelPelasInformacoesDRI: string;
  bancoLiquidanteEmissor: string;
  cnpjBancoLiquidanteEmissor: string;
  codigoBancoContaCorrenteVinculadaEmissao: string;
  numeroAgenciaContaCorrenteVinculadaEmissao: string;
  numeroContaCorrenteVinculadaEmissao: string;
  tipoLiquidacao: Option;
  chaveExterna: string;
  descricaoAdicional: string;
  razaoSocialEscriturador: string;
  cnpjEscriturador: string;
  coordenadoresIds: Array<string>;
  coordenadorLiderId: string;
  razaoSocialAgenteFiduciario: string;
  cpfCnpjAgenteFiduciario: string;
  naturezaAgenteFiduciario: Option;
  nomeGarantidor: string;
  cpfCnpjGarantidor: string;
  naturezaGarantidor: Option;
  cnpjEmissor: string;
  numeroEmissaoOriginal?: string;
  possuiVasosComunicantes: Option;
}

export const caracteristicasInitialState: CaracteristicasState = {
  // codigoInstrumentoFinanceiro: '',
  isin: '',
  numeroEmissao: '',
  numeroSerie: '',
  statusEmissao: '' as EmissaoStatus,
  tipoSerie: tipoSerieOptions[0],
  regimeFiduciario: booleanOptions[0],
  coobrigacao: booleanOptions[0],
  distribuicaoPublica: booleanOptions[0],
  tipoDistribuicaoPublica: tipoDistribuicaoPublicaOptions[0],
  contraparteRecebedora: contraparteRecebedoraOptions[0],
  negociacaoSecundariaPor: negociacaoSecundariaOptions[0],
  termoSecuritizacaoFormalizado: booleanOptions[0],
  depositariaEmissao: depositariaEmissaoOptions[0],
  codigoCvmCiaSecuritizadora: '',
  utilizacaoAnuncioInicioDistribuicao: booleanOptions[0],
  ufLocalEmissao: unidadeFederativaOptions[0],
  localEmissao: '',
  dataEncerramentoDistribuicao: undefined,
  classificadoraRisco1: '',
  rating1: '',
  classificadoraRisco2: '',
  rating2: '',
  ufLocalPagamento: unidadeFederativaOptions[0],
  localPagamento: '',
  averbadoEmCartorio: booleanOptions[0],
  registroNaInstituicaoCustodiante: booleanOptions[0],
  utilizacaoFaculdadeParagrafo3Art7: booleanOptions[1],
  garantiaFlutuante: booleanOptions[0],
  tipoGarantia: '',
  ativoGarantia: '',
  valorGarantia: 0,
  nomeResponsavelPelasInformacoesDRI: '',
  emailResponsavelPelasInformacoesDRI: '',
  bancoLiquidanteEmissor: '',
  cnpjBancoLiquidanteEmissor: '',
  codigoBancoContaCorrenteVinculadaEmissao: '',
  numeroAgenciaContaCorrenteVinculadaEmissao: '',
  numeroContaCorrenteVinculadaEmissao: '',
  tipoLiquidacao: tipoLiquidacaoOptions[0],
  chaveExterna: '',
  descricaoAdicional: '',
  razaoSocialEscriturador: '',
  cnpjEscriturador: '',
  coordenadoresIds: [],
  coordenadorLiderId: '',
  razaoSocialAgenteFiduciario: '',
  cpfCnpjAgenteFiduciario: '',
  naturezaAgenteFiduciario: naturezaPessoaOptions[0],
  nomeGarantidor: '',
  cpfCnpjGarantidor: '',
  naturezaGarantidor: naturezaPessoaOptions[0],
  cnpjEmissor: '',
  numeroEmissaoOriginal: '',
  possuiVasosComunicantes: booleanOptions[1],
  ...multaMoraFieldsInitialState,
};

export interface MetadataState {
  series: Array<Option>;
  negociacoesSecundarias: Array<Option>;
  options: Array<Option>;
  depositariaEmissoes: Array<Option>;
  tipoDistribuicaoPublica: Array<Option>;
  contraparteRecebedora: Array<Option>;
  naturezaPessoa: Array<Option>;
  unidadesFederativas: Array<Option>;
  tiposLiquidacao: Array<Option>;
  investidores: Array<InvestidorResponse>;
}

export const metadataInitialState: MetadataState = {
  series: tipoSerieOptions,
  negociacoesSecundarias: negociacaoSecundariaOptions,
  options: booleanOptions,
  depositariaEmissoes: depositariaEmissaoOptions,
  tipoDistribuicaoPublica: tipoDistribuicaoPublicaOptions,
  contraparteRecebedora: contraparteRecebedoraOptions,
  naturezaPessoa: naturezaPessoaOptions,
  unidadesFederativas: unidadeFederativaOptions,
  tiposLiquidacao: tipoLiquidacaoOptions,
  investidores: [],
};

interface Field {
  name: keyof CaracteristicasState;
  value: number
  | string
  | boolean
  | undefined | null | Moment | Option | Array<string>;
}

interface MetadataField {
  name: keyof MetadataState;
  value: Array<Option> | Array<InvestidorResponse>;
}

export const updateField = (field: Field) => {
  return typedAction('cdca/caracteristicas/UPDATEFIELD', field);
};

export const updateMetadata = (field: MetadataField) => {
  return typedAction('cdca/metadata/UPDATEFIELD', field);
};

export const resetMetadata = () => {
  return typedAction('cdca/metadata/RESET');
};

export const resetCdcaDetails = () => {
  return typedAction('cdca/caracteristicas/RESET');
};

export const updateCdcaCaracteristicas = (state: CaracteristicasState) => {
  return typedAction('cdca/caracteristicas/UPDATE', state);
};

export type CaracteristicasAction = ReturnType<
  | typeof updateField
  | typeof resetCdcaDetails
  | typeof updateMetadata
  | typeof updateCdcaCaracteristicas
  | typeof resetMetadata
>;
